import {
  USER_GETALL_SUCCESS,
  USER_GETALL_FAIL,
  USER_DELETE_SUCCESS,
  USER_DELETE_FAIL,
  USER_UPSERT_SUCCESS,
  USER_UPSERT_FAIL,
} from "../actions/types";

const userarray = JSON.parse(localStorage.getItem("users"));

const initialState = userarray
  ? { users: userarray }
  : { users: null };

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case USER_GETALL_SUCCESS:
      return {
        ...state,
        users: payload.users
      };
    case USER_DELETE_SUCCESS:
      return {
        ...state,
        users: state.users.filter(user => user.id !== payload)
      };
    case USER_UPSERT_SUCCESS:
      if (state.users.filter(e => e.id == payload.id).length > 0) {
        return { ...state, users: state.users.map(user => { return user.id === payload.id ? payload : user }) };
      } else {
        return { ...state, users: [...state.users, payload] }
      }
    default:
      return state;
  }
}